<template>
  <div class="basket-header">
    <!-- Заголовок и кнопка закрытия (крестик переехал сюда — освобождает верхнюю строку) -->
    <div class="flex gap-3 xl:pt-4 pl-2 pb-4 items-center justify-between">
      <div class="basket-header__title">{{ $t('basket') }}</div>
      <UiButtonMain
        icon="i-heroicons-x-mark-solid"
        size="xxl"
        class="basket-header__close"
        aria-label="Закрыть корзину"
        @click="handleClose"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Emits {
  (e: 'close'): void
}

const emit = defineEmits<Emits>()

/**
 * Обрабатывает закрытие корзины
 */
function handleClose(): void {
  emit('close')
}
</script>

<style scoped lang="scss">
.basket-header {
  @apply relative;

  &__close {
    @apply dark:text-white flex-shrink-0 h-10 w-10  z-10 xl:hidden text-black bg-transparent dark:bg-transparent;
  }

  &__title {
    @apply text-xl sm:text-2xl font-semibold;
    // Заголовок корзины — одно из мест фирменного шрифта заведения
    font-family: var(--app-brand-font, inherit);
    margin-bottom: 0 !important;
  }
}
</style>